<template>
    <div class="requisites_card">
        <div class="requisites_card__header">
            <div class="requisites_card__header_payment">
                <img :src="withdrawal!.psystem!.imgPath" alt="">
                <p class="requisites_card__header_payment_name">{{ withdrawal!.psystem.name }}</p>
            </div>
        </div>
        <div class="requisites_card__body">
            <transition name="fade" mode="out-in">
                <template v-if="requisites">
                    <div class="available-content">
                        <div class="address" @click="copy(requisites.address!)">
                            <template v-if="requisites.addressType === BuyingRequisiteAddressTypes.PHONE">
                                <p class="title">{{ $t('light-payment.requisites.with-phone') }}</p>
                            </template>
                            <template v-else-if="requisites.addressType === BuyingRequisiteAddressTypes.CARD">
                                <p class="title">{{ $t('light-payment.requisites.with-card') }}</p>
                            </template>
                            <p class="text">{{ withdrawal!.requisites!.address }}
                                <i class="display-block copy-svg"></i>
                            </p>
                        </div>
                        <div class="available-content_row">
                            <div class="agent">
                                <p class="title">{{ $t('light-payment.requisites.recipient') }}</p>
                                <p class="text">{{ withdrawal!.requisites.name }}</p>
                            </div>
                            <div class="amount">
                                <p class="title">{{ $t('light-payment.requisites.amount') }}</p>
                                <p class="text">{{ withdrawal!.amount }} {{ withdrawal!.currency!.getABBR() }}</p>
                            </div>
                        </div>
                    </div>
                </template>
            </transition>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, PropType, toRef} from "vue";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import {f7} from "framework7-vue";
import {BuyingRequisiteAddressTypes} from "@enums/BuyingRequisiteAddressTypes";
import {ToRef} from "@vue/runtime-core";
import WithdrawalOperation from "@models/operations/WithdrawalOperation";
import {useI18n} from "vue-i18n";

const props = defineProps({
    withdrawal: {
        type: Object as PropType<WithdrawalOperation>,
        required: true
    }
});

const withdrawal: ToRef<WithdrawalOperation> = toRef(props, 'withdrawal');
const requisites = computed(() => withdrawal.value!.requisites);
const {t} = useI18n({useScope: 'global'});

function copy(value: string) {
    const aux = document.createElement("input");
    aux.setAttribute("value", value);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);

    f7.toast.create({
        text: t('g.copied'),
        position: 'top',
        closeTimeout: 1000,
    }).open();
}
</script>

<style lang="scss">
.requisites_card {
    width: 100%;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 20px;
    background-color: var(--grey9);
    border: 0.5px solid var(--grey8);
    display: flex;
    flex-direction: column;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &_payment {
            display: flex;
            gap: 4px;

            img {
                width: 24px;
                height: 24px;
            }

            &_name {
                @include text(20px, 500, var(--brown1), 24px);
            }
        }

        .amount {
            display: flex;
            align-items: center;
            gap: 8px;

            p {
                @include text(24px, 700, var(--brown1), 28.8px);
            }

            i {
                cursor: pointer;
            }
        }
    }

    &__body {
        margin-top: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;

        .available-content {
            display: flex;
            flex-direction: column;
            gap: 16px;
            flex: 1;

            &_row {
                display: flex;
                gap: 8px;
                justify-content: space-between;
            }
        }

        .address {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .title {
                @include text(14px, 400, var(--grey2), 19.2px);
            }

            .text {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                @include text(20px, 500, var(--brown1), 24px);

                i {
                    margin-top: 2px;
                    cursor: pointer;
                }
            }
        }

        .agent {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .title {
                @include text(14px, 400, var(--grey2), 19.2px);
            }

            .text {
                @include text(16px, 500, var(--brown1), 19.2px);
            }
        }

        .amount {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .title {
                @include text(14px, 400, var(--grey2), 19.2px);
            }

            .text {
                @include text(16px, 500, var(--brown1), 19.2px);
            }
        }
    }
}
</style>